/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './custom-merchandise.stache';
import can from 'can';
import Swiper from 'swiper';
import appContext from 'scripts/app-context';
import _ from 'lodash';
import dtm from 'scripts/services/dtm';
import { sendMerchandiseUnitClickAnalitycs } from './controllers/analitycs.controller';

Component.extend({
    tag: 'custom-merchandise',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            merchandise: {
                Type: can.Map,
                Value: null,
            },
            ctaLink: {
                Type: can.Map,
                Value: null,
            },
            isMobile: {
                get() {
                    return (
                        ['small', 'extra-small'].indexOf(
                            appContext.model.screen.attr('screenSize'),
                        ) > -1
                    );
                },
            },
            sourcePageName: {
                get() {
                    return dtm.getPageName();
                },
            },
            showNavigation: {
                get() {
                    const merchandise = this.attr('merchandise').serialize();
                    return Boolean(Object.keys(merchandise).length);
                },
            },
        },

        switchLink(productIndex) {
            if (!this.ctaInsideSlide) {
                return;
            }

            const path = `[${productIndex}].link`;
            const firstLink = _.get(this.merchandise, path);
            if (!!firstLink) {
                this.attr('ctaLink', firstLink);
            }
        },
    },
    events: {
        inserted($element) {
            const cloudinaryImage = this.element
                .find('image-cloudinary')
                .viewModel();
            cloudinaryImage.bind('cloudinaryImageLoaded', () => {
                _.delay(this.initSwiper.bind(this, $element[0]), 500);
                cloudinaryImage.unbind('cloudinaryImageLoaded');
            });
        },

        initSwiper(element) {
            const customSwiperOptions = {
                loop: true,
                simulateTouch: true,
                speed: 1000,
                navigation: {
                    nextEl: element.querySelector('.swiper-button--next'),
                    prevEl: element.querySelector('.swiper-button--prev'),
                },
            };

            const swiperConfig = _.assign(
                customSwiperOptions,
                this.viewModel.swiperOptions,
            );

            this.swiper = new Swiper(
                element.querySelector('.custom-merchandise-swiper-container'),
                swiperConfig,
            );
        },

        handleLinkClick(link) {
            if (!link) return;

            const linkUrl = _.get(link, 'url');
            const linkTarget =
                _.get(link, 'target') === 'new' ? '_blank' : '_self';

            sendMerchandiseUnitClickAnalitycs(linkUrl);
            window.open(linkUrl, linkTarget);
        },

        '.js-link click'(el, event) {
            event.stopPropagation();
            const merchandise = this.viewModel.attr('merchandise');
            const index = _.get(this.swiper, 'realIndex');
            const link = _.get(merchandise, `${index}.link`);
            this.handleLinkClick(link);
        },

        '.js-cta-link click'() {
            this.handleLinkClick(this.viewModel.attr('ctaLink'));
        },
    },
});
